import { module as modujs } from "modujs";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		this.$turnings = this.$("turning");
		this.$loadings = this.$("loading");
		this.$drawings = this.$("drawing");

		this.$turnings.forEach((el) => {
			// Si jamais ils veulent que les formes tournent au scroll :
			// let rotation = 0;
			// let targetRotation = 0;
			// const speed = 0.1;

			// gsap.to(el, {
			// 	rotation: 360,
			// 	duration: 1,
			// 	ease: "none",
			// 	repeat: -1,
			// 	scrollTrigger: {
			// 		trigger: el,
			// 		start: "top bottom",
			// 		end: "bottom top",
			// 		scrub: true,
			// 		onUpdate: (self) => {
			// 			targetRotation = self.progress * 360;

			// 			rotation += (targetRotation - rotation) * speed;
			// 			gsap.set(el, { rotation: rotation });
			// 		},
			// 	},
			// });

			gsap.fromTo(
				el,
				{
					rotate: 0,
				},
				{
					rotate: 360,
					duration: 15,
					ease: "none",
					repeat: -1,
				}
			);
		});

		this.$loadings.forEach((el) => {
			var tl = gsap.timeline({ repeat: -1 });
			let circle = el.querySelector("circle");

			tl.from(circle, {
				drawSVG: 0,
				ease: "none",
				duration: 5,
			});
		});

		this.$drawings.forEach((el) => {
			let path = el.querySelector("path");
			var tl = gsap.timeline();

			tl.from(path, {
				drawSVG: 0,
				ease: "none",
				duration: 10,
			});
		});
	}

	destroy() {}
}
